<section class="step-container">
  <div class="step-body">
    <ng-template appHost></ng-template>
  </div>
  @if (internalNavigation) {
    <div
      class="next-container"
        [ngClass]="{'next-container-align-right': !internalBackVisible,
        'next-container-align-left': !internalNextVisible,
        'next-container-align-space': internalBackVisible && internalNextVisible}">
      <button
        class="back-btn"
        (click)="internalPreviousView()"
      [hidden]="!internalBackVisible">Back</button>
      <button
        class="next-btn"
        (click)="internalNextView()"
      [hidden]="!internalNextVisible">Next</button>
    </div>
  }
  @if (!internalNavigation) {
    <div
      class="next-container"
        [ngClass]="{'next-container-align-right': selectedIndex === 0,
        'next-container-align-space': selectedIndex !== 0}">
      <button
        class="back-btn"
        (click)="previousView()"
        [hidden]="selectedIndex === 0"
      >Back</button>
      <button
        class="next-btn"
        (click)="nextView()"
      [hidden]="disabledNavigation">Next</button>
    </div>
  }
  <hr>
    <footer class="step-navigation-bar">
      @for (step of steps; track step; let i = $index) {
        <button
          class="step"
        [ngClass]="{'step-active': selectedIndex === i,
                    'step-non-active': selectedIndex !== i && !visited[i],
                    'step-access': selectedIndex !== i && visited[i]}"
          (click)="selectedview(i)"
        >{{i+1}}</button>
      }
    </footer>
  </section>